import styled from 'styled-components';
import Theme from '../../theme';

const Panel = styled.div`
  ${Theme.styles.panelDropShadow};
  ${Theme.styles.componentSmallRadius};
  padding: ${Theme.spacing.small};
  margin-bottom: ${Theme.spacing.small};
  background-color: ${Theme.colours.white};
`;

/** @component */
export default Panel;
